import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/ListeningSection.css";
import Part1_1 from "../questionCards/Part1/Part1_1";
import Part2_1 from "../questionCards/Part2/Part2_1";
import Part3_1 from "../questionCards/Part3/Part3_1";

const ListeningSection = () => {
  const [curriculum, setCurriculum] = useState([
    {
      id: 1,
      part: "Part 1",
      topic: "사진 묘사 - 사무실 상황",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "기초",
    },
    {
      id: 2,
      part: "Part 2",
      topic: "WH 질문 응답하기",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 3,
      part: "Part 3",
      topic: "일상 대화 이해하기",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 4,
      part: "Part 3",
      topic: "인사 & 교육 & 행사 & 정책",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 5,
      part: "Part 3",
      topic: "비즈니스 & 마케팅 & 영업 & 커뮤니케이션",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 6,
      part: "Part 3",
      topic: "재무 & 회계 & 투자 & 보험",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 7,
      part: "Part 3",
      topic: "여가 & 렌탈 & 교통 & 예약",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 8,
      part: "Part 3",
      topic: "일상생활",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "중급",
    },
    {
      id: 9,
      part: "Part 4",
      topic: "공지사항 듣기",
      status: "미학습",
      planDate: "",
      reviewDate: "",
      difficulty: "고급",
    },
  ]);

  const handleDateChange = (id, field, value) => {
    setCurriculum((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  };

  return (
    <div className="listening-section">
      <h2>TOEIC Listening 학습 계획표</h2>
      <table className="curriculum-table">
        <thead>
          <tr>
            <th>파트</th>
            <th>학습 주제</th>
            <th>난이도</th>
            <th>학습 상태</th>
            <th>학습 예정일</th>
            <th>복습 예정일</th>
          </tr>
        </thead>
        <tbody>
          {curriculum.map((item) => (
            <tr key={item.id}>
              <td>{item.part}</td>
              <td>
                <Link to={`/dashboard/listening/${item.part.replace(" ", "")}`}>
                  {item.topic}
                </Link>
              </td>
              <td>
                <span
                  className={`difficulty-badge ${item.difficulty.toLowerCase()}`}
                >
                  {item.difficulty}
                </span>
              </td>
              <td>
                <select
                  value={item.status}
                  onChange={(e) =>
                    handleDateChange(item.id, "status", e.target.value)
                  }
                  className={item.status.toLowerCase()}
                >
                  <option value="미학습">미학습</option>
                  <option value="학습중">학습중</option>
                  <option value="완료">완료</option>
                </select>
              </td>
              <td>
                <input
                  type="date"
                  value={item.planDate}
                  onChange={(e) =>
                    handleDateChange(item.id, "planDate", e.target.value)
                  }
                />
              </td>
              <td>
                <input
                  type="date"
                  value={item.reviewDate}
                  onChange={(e) =>
                    handleDateChange(item.id, "reviewDate", e.target.value)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListeningSection;
